import { useState } from 'react';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import ProductNav from '@/components/ProductCommon/ProductNav';
import ProductSpecs from '@/components/ProductCommon/ProductSpecs';
import ProductSupport, { SupportData } from '@/components/ProductCommon/ProductSupport';
import PageConH5 from '@/components/productSmart/Mh200/Mh200H5';
import PageConPc from '@/components/productSmart/Mh200/Mh200Pc';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/wave-portable-air-conditioner';
import { getProductMsg, getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useSupportData } from '@/utils/hooks';
import Annotation from '@/components/Annotation';

// 产品详情页参数
const productName = 'wave-portable-air-conditioner';
const generalKey = 'product_ac_wave';

export default function Page({ SEO }: any) {
    const { isMobile, gloproductlist, useRouter } = useGlobal();
    const PageCon = isMobile ? PageConH5 : PageConPc;
    const [theme, setTheme] = useState('');
    const router = useRouter();
    const { locale } = router;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: generalKey });
    // 如果不存在该页面,返回404
    if (!productMsg.generalKey && gloproductlist.length && typeof window !== 'undefined') {
        return router.push(`${location.origin}/${router.locale}/404`);
    }

    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg);

    // 切换tab
    const tabState = (val: any) => {
        document.querySelector('.product-tab.show-tab')?.classList.remove('show-tab');
        document.querySelector(`.product-tab-${val}`)?.classList.add('show-tab');
    };

    return (
        <>
            <SEO title={productMsg.title} description={productMsg.description} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <GtmPageLoad />
            <PageLayout className={`${css.productcontent} ${theme} product_common product_common_real product_common_0426`} theme={theme}>
                <ProductNav
                    className="wbg"
                    title={productMsg?.name}
                    theme={theme}
                    buyLink={productMsg?.buyLink || ''}
                    callback={tabState}
                    productKey={productName}
                />
                <div className="product-tab product-tab-Overview show-tab">
                    <PageCon />
                    <Annotation borderTopColor="transparent" bgColor="transparent" product="WAVE" boxStyle={isMobile ? {} : { width: '1120px' }} />
                </div>
                <div className="product-tab product-tab-Specs">
                    <ProductSpecs theme={theme} productDetail={productDetail} resProductCatagory={resProductCatagory} />
                </div>
                <div className="product-tab product-tab-Support">
                    <ProductSupport theme={theme} supportData={supportData as SupportData}></ProductSupport>
                </div>
            </PageLayout>
        </>
    );
}
